import { Controller } from "@hotwired/stimulus";

// Validates the exclude/radiate student form before submission
export default class extends Controller {
  static targets = ["input", "error"];

  submit(event) {
    const value = this.inputTarget.value.trim();
    if (value === "") {
      event.preventDefault();
      this.inputTarget.classList.add("border-red-500");
      this.inputTarget.classList.remove("border-gray-100");
      this.errorTarget.classList.remove("hidden");
    } else {
      this.errorTarget.classList.add("hidden");
      this.inputTarget.classList.remove("border-red-500");
      this.inputTarget.classList.add("border-gray-100");
    }
  }

  clearError() {
    if (this.inputTarget.value.trim() !== "") {
      this.errorTarget.classList.add("hidden");
      this.inputTarget.classList.remove("border-red-500");
      this.inputTarget.classList.add("border-gray-100");
    }
  }
}
